import { Component, HostListener, Input } from '@angular/core';
import { NotificationService } from '../../../core/notifications.service';

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.html',
  styleUrls: ['./info-popup.scss']
})
export class InfoPopup {
  defaultTitle: string = $localize`:popup.info.title:שימו לב!`;
  @Input() title: string | null = null;
  @Input() message: string | null = null;

  get displayTitle(): string {
    return this.title || this.defaultTitle;
  }

  constructor(private notificationService: NotificationService) {}

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (!this.message) return;
    if (event.key !== 'Enter' && event.key !== 'Escape') return;
    event.preventDefault();
    this.onConfirm();
  }

  onConfirm() {
    this.notificationService.hideInfo();
    queueMicrotask(() => this.focusFirstOtpCellIfPresent());
  }

  private focusFirstOtpCellIfPresent(): void {
    document.querySelector<HTMLElement>('.otp-input .otp-cell')?.focus();
  }
}
